import Restriction from './Restriction';

var RouterPropTypes = require('react-router/lib/PropTypes');
var vsprintf = require('sprintf-js').vsprintf;
var React = require('react');
var Address = require('../../util/Address');
var AttributeTable = require('../AttributeTable');
var Ip = require('../Ip/Ip');
var IpUtil = require('../../util/Ip');
var ServiceTypes = require('../../constants/ServiceTypes');
var Invocation = require('../../api/Invocation');
var ButtonLink = require('react-router-bootstrap').ButtonLink;

var ServiceDetails = React.createClass({
    contextTypes: {
        router: RouterPropTypes.router.isRequired
    },
    propTypes: {
        service: React.PropTypes.object.isRequired
    },
    render: function () {
        const service = this.props.service;
        const type = service.service.group ?
            ServiceTypes.getType(service.service.group) :
            ServiceTypes.getTypeByConstant(service.service.type);
        let attributes = [];
        const upgradable = this.props.upgradable

        let pendingPlanChange = false;
        if (service.restrictions) {
            for (let i = 0; i < service.restrictions.length; i++) {
                const restrictionType = service.restrictions[i].type;
                if (restrictionType === 'plan_change') {
                    pendingPlanChange = true;
                }
            }
        }

        attributes.push({
            name: 'Service Type',
            value: type.name
        });
        attributes.push({
            name: 'Service Identifier',
            value: IpUtil.format(service.identifier, true)
        });
        attributes.push({
            name: 'Plan Name',
            value: (<div>
              {upgradable && !pendingPlanChange && (<ButtonLink to="service-upgrade" bsSize="xs" bsStyle="warning" className="pull-right" params={{ serviceId: service.id }}>Change Plan</ButtonLink>)}
              {service.service_display_name}
            </div>)
        });
        attributes.push({
          name: 'Reference',
          value: service.reference
        })

        if (service.clientReference) {
            attributes.push({
                name: 'Client Reference',
                value: service.clientReference
            });
        }
        if (service.site) {
            var site = service.site;

            attributes.push({
                name: 'Site',
                value: <address style={{marginBottom: 0}}>
                    <strong>{site.name}</strong><br />
                    <div className="small low">{Address.formatFromApi(site)}</div>
                </address>
            });
        }
        if (service.billing_group) {
            attributes.push({
                name: 'Billing Group',
                value: service.billing_group.name,
                help: 'A billing group can be used to split different service types into different invoices or a different company name.'
            })
        }
        if (service.authentication) {
            attributes.push({
                name: 'Username',
                value: service.authentication.username
            });
        }
        if (service.transit) {
            if (!service.shared_hosting && service.transit.wan_ip) {
                attributes.push({
                    name: <span>
                        <div>WAN IP Address</div>
                    </span>,
                    value: <Ip ip={service.transit.wan_ip} />
                });
            }

            if (service.transit.ip_ranges) {
                attributes.push({
                    name: 'Additional IP Ranges',
                    value: service.transit.ip_ranges.map(function (range) {
                        return IpUtil.format(range);
                    }).join(', ')
                });
            }

            if (service.transit.hostname) {
                attributes.push({
                    name: 'Hostname',
                    value: service.transit.hostname
                });
            }
        }
        if (service.supplier && service.supplier.nbnUnid && service.supplier.nbnUnid.length > 0) {
            attributes.push({
              name: 'NBN UNID',
              value: service.supplier.nbnUnid[0]
            })
        }
        if (service.supplier && service.supplier.drop_length !== null && service.supplier.drop_length !== undefined) {
            attributes.push({
              name: 'Cable Drop Length',
              value: service.supplier.drop_length + 'm'
            })
        }
        if (service.shared_hosting) {
            if (service.shared_hosting.domain) {
                attributes.push({
                    name: 'Domain name',
                    value: service.shared_hosting.domain
                });
            }
            if (service.transit && service.transit.wan_ip) {
                attributes.push({
                    name: <span>
                        <div>Dedicated IP Address</div>
                    </span>,
                    value: <Ip ip={service.transit.wan_ip} />
                });
            }

            attributes.push({
                name: 'Manage Hosting',
                value: <a className="btn btn-primary" href={this.context.router.makeHref('cpanel-redirect', {serviceId: service.id})} target="_blank">Login to Hosting Control Panel</a>
            });
        }
        if (service.restrictions && service.restrictions.length) {
            const restrictions = service.restrictions.map(
                (restriction, i) => <Restriction key={i} restriction={restriction} />
            );

            attributes.push({
                name: 'Restrictions',
                value: restrictions
            });
        }

        return <AttributeTable attributes={attributes} />;
    }
})
module.exports = ServiceDetails;



// WEBPACK FOOTER //
// ./app/components/ClientService/ServiceDetails.js